import get from 'lodash/get';
export const UPDATE_EMI_BANK = 'UPDATE_EMI_BANK';
export const UPDATE_EMI_TENURE = 'UPDATE_EMI_TENURE';
export const UPDATE_EMI_SECTION = 'UPDATE_EMI_SECTION';
export function updateEmiBankAction(bankCode, bankEmiType, bankEmiKey, bankName, shouldOpen2FASection) {
    return { type: UPDATE_EMI_BANK, bankCode, bankEmiType, bankEmiKey, bankName, shouldOpen2FASection };
}
export function updateEmiTenureAction(tenure) {
    return (dispatch, getState) => {
        const paymentsState = get(getState(), ['payments']);
        return dispatch({ type: UPDATE_EMI_TENURE, tenure, paymentsState });
    };
}
export function updateEmiSectionAction(section, key) {
    return {
        type: UPDATE_EMI_SECTION,
        section,
        key
    };
}
